import { render, staticRenderFns } from "./NewProtocol.vue?vue&type=template&id=4fd29bf3&scoped=true&"
import script from "./NewProtocol.vue?vue&type=script&lang=js&"
export * from "./NewProtocol.vue?vue&type=script&lang=js&"
import style0 from "./NewProtocol.vue?vue&type=style&index=0&id=4fd29bf3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fd29bf3",
  null
  
)

export default component.exports